import { Container, Title, Text, Stack } from '@mantine/core';
import { useTheme } from '../theme/theme';

export const TermsPage = () => {
  const theme = useTheme();

  return (
    <Container size='md' py='xl'>
      <Stack gap='lg'>
        <Title order={1}>Terms of Service</Title>
        <Text c={theme.v0.col.textDimmed.hex} size='sm'>
          Last updated: {new Date().toLocaleDateString()}
        </Text>

        <div>
          <Title order={2} size='h3' mb='xs'>
            1. Agreement to Terms
          </Title>
          <Text>
            By accessing and using epilogo., you accept and agree to be bound by the terms and provision of this
            agreement.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            2. Use License
          </Title>
          <Text>
            Permission is granted to temporarily download one copy of the materials (information or software) on
            epilogo. for personal, non-commercial transitory viewing only. This is the grant of a license, not a
            transfer of title, and under this license you may not:
          </Text>
          <ul>
            <li>Modifying or copying the materials</li>
            <li>Using the materials for any commercial purpose or for any public display</li>
            <li>Attempting to decompile or reverse engineer any software contained on epilogo.</li>
            <li>Removing any copyright or other proprietary notations from the materials</li>
            <li>
              Transferring the materials to another person or "mirroring" the materials on any other server
            </li>
          </ul>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            3. Disclaimer
          </Title>
          <Text>
            The materials on epilogo are provided on an 'as is' basis. Epilogo SRL makes no warranties, expressed or
            implied, and hereby disclaims and negates all other warranties including, without limitation, implied
            warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of
            intellectual property or other violation of rights.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            4. Limitations
          </Title>
          <Text>
            In no event shall Epilogo SRL or its suppliers be liable for any damages (including, without limitation,
            damages for loss of data or profit, or due to business interruption) arising out of the use or inability to
            use the materials on epilogo., even if Epilogo SRL or an authorized representative has been notified orally
            or in writing of the possibility of such damage.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            5. Accuracy of Materials
          </Title>
          <Text>
            The materials appearing on epilogo could include technical, typographical, or photographic errors. Epilogo
            SRL does not warrant that any of the materials on epilogo are accurate, complete, or current. Epilogo SRL
            may make changes to the materials contained on epilogo at any time without notice.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            6. Links
          </Title>
          <Text>
            Epilogo SRL has not reviewed all of the sites linked to its website and is not responsible for the contents
            of any such linked site. The inclusion of any link does not imply endorsement by Epilogo SRL of the site.
            Use of any such linked website is at the user's own risk.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            7. Modifications
          </Title>
          <Text>
            Epilogo SRL may revise these terms of service for epilogo at any time without notice. By using this website,
            you are agreeing to be bound by the then current version of these terms of service.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            8. Governing Law
          </Title>
          <Text>
            These terms and conditions are governed by and construed in accordance with the laws of Italy, and you
            irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='xs'>
            9. Contact Us
          </Title>
          <Text>
            If you have any questions about these Terms of Service, please contact us at support@epilogo.co
          </Text>
        </div>
      </Stack>
    </Container>
  );
};
